module.exports = __webpack_public_path__ + "img/icon-whatsapp.ba46da0d.svg";